import React, { useEffect, useState } from 'react';
import {
  PaymentRequestButtonElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import { PaymentRequest } from '@stripe/stripe-js';
import { PaymentRequestDto } from 'types/payment-request-dto';
import { useDispatch } from 'react-redux';
import { setStripeWallet } from 'app/wallet/store/wallet.slice';

interface WalletPayButtonProps {
  paymentRequestDto: PaymentRequestDto;
  clientSecret: string;
  walletPaymentMethod: string | null;
  handleConfirmPayment: () => void;
  onError: () => void;
}

const WalletPayButton = ({
  paymentRequestDto,
  clientSecret,
  walletPaymentMethod,
  handleConfirmPayment,
  onError,
}: WalletPayButtonProps) => {
  const dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();

  const [paymentRequest, setPaymentRequest] = useState<PaymentRequest | null>(
    null
  );

  useEffect(() => {
    if (!stripe || !elements) {
      return;
    }

    const pr = stripe.paymentRequest(paymentRequestDto);

    pr.canMakePayment().then((result) => {
      if (result?.googlePay || result?.applePay) {
        const stripeWallet = {
          googlePay: result.googlePay,
          applePay: result.applePay,
        };
        dispatch(setStripeWallet(stripeWallet));
        setPaymentRequest(pr);
      }
    });

    pr.on('paymentmethod', async (e) => {
      const { error: stripeError, paymentIntent } =
        await stripe.confirmCardPayment(
          clientSecret,
          {
            payment_method: e.paymentMethod.id,
          },
          { handleActions: false }
        );

      if (stripeError) {
        onError();
        e.complete('fail');
        return;
      }

      e.complete('success');
      if (paymentIntent && paymentIntent.status === 'requires_action') {
        const { error } = await stripe.confirmCardPayment(clientSecret);

        if (error) {
          onError();
          return;
        }
      }

      handleConfirmPayment();
    });
  }, [
    stripe,
    elements,
    paymentRequestDto,
    clientSecret,
    onError,
    handleConfirmPayment,
    dispatch,
  ]);

  return (
    <>
      {paymentRequest && walletPaymentMethod && (
        <PaymentRequestButtonElement
          className="payment-button"
          options={{
            paymentRequest,
            style: {
              paymentRequestButton: {
                theme: 'light',
                height: '64px',
              },
            },
          }}
        />
      )}
    </>
  );
};

export default WalletPayButton;
